import { ConsumerPurchaseSummary } from 'generated/graphql';
import { centerCropThumbnailUrlSquare } from '@tock/images';
import { getReservationLink } from 'utils/profileUtils';
import { useHistory } from 'react-router';
import LazyImage from '@tock/shared/components/LazyImage';
import ReservationDetails from 'components/profile/ReservationDetails';

interface Props {
  reservation: ConsumerPurchaseSummary;
}

const ReservationCard = ({ reservation, reservation: { business } }: Props) => {
  const { push } = useHistory();
  const goToManagePage = () => {
    const link = getReservationLink(reservation);
    if (link) {
      push(link);
    }
  };

  const resBusiness = business;

  const image = resBusiness?.images?.length > 0 ? resBusiness.images[0] : undefined;
  const sectionClassName = 'ReservationCard-section';

  return (
    <button className="ReservationPreviewCard" onClick={goToManagePage} tabIndex={0}>
      <div className="ReservationPreviewCard-data">
        <div className="ReservationPreviewCard-details">
          <ReservationDetails
            reservation={reservation}
            title={(resBusiness && resBusiness.name) || undefined}
            size="LARGE"
          />
          <div className={sectionClassName}></div>
        </div>
        {image && image.imageUrl && (
          <div className="ReservationPreviewCard-imageWrapper">
            <LazyImage
              src={centerCropThumbnailUrlSquare(image.imageUrl)}
              alt={image.altText || undefined}
              backgroundColor={image.dominantColor || undefined}
              className="ReservationPreviewCard-image"
            />
          </div>
        )}
      </div>
    </button>
  );
};

export default ReservationCard;
